<template>
	<CDialog
		title="Archive Form?"
		:visible="show"
		custom-class="dialog--narrow"
		@closed="$emit('close')"
	>
		<p>Once archived, forms will no longer be publicly available and will no longer receive entries. You can restore archived forms at any time.</p>
		<p class="font-semibold mt-3">Are you sure you want to archive?</p>
		<template #footer>
			<CCallout v-if="showError" type="error" size="s" title="An error occurred." />
			<template v-else>
				<button class="button button button--secondary" @click="$emit('close')">
					Cancel
				</button>
				<button class="button button--primary" @click="$emit('confirm-archive')">
					Archive
				</button>
			</template>
		</template>
	</CDialog>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';
	import CDialog from 'src/components/dialogs/Dialog.vue';
	import CCallout from 'src/components/content/Callout.vue';

	export default defineComponent({
		name: 'ArchiveFormsDialog',
		components: {
			CDialog,
			CCallout
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			showError: {
				type: Boolean,
				default: false
			}
		}
	});
</script>